<template>
    <div class="more-block-modal">
        <div class="height-base-title" @click="hideModal"><i class="return"></i>{{ $t("zhiji.wiki.cameback") }}</div>
        <div class="list">
            <MoreBlockList v-model="listData" :lang="data.lang" :blockData="data.rowData"></MoreBlockList>
            <div class="list-bottom" align="right">
                <el-button round @click="hideModal">{{ $t("zhiji.common.cancel") }}</el-button>
                <el-button round type="primary" @click="saveClick">{{ $t("zhiji.common.save") }}</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import MoreBlockList from "./MoreBlockList";

export default {
    name: "MoreBlockModal",
    props: ["data"],
    components: {
        MoreBlockList
    },
    data() {
        return {
            listData: []
        };
    },
    methods: {
        hideModal() {
            this.$store.dispatch("zhiji/hideModal", { type: "MoreBlockModal" });
        },
        queryResourceList() {
            this.zhiji
                .requestByServiceName("queryResourceList", {
                    lang: this.data.rowData.lang,
                    page: 1,
                    size: 50,
                    sectionId: this.data.rowData.id
                })
                .then(res => {
                    this.listData = res.list;
                });
        },
        saveClick() {
            this.zhiji
                .requestByServiceName("batchSaveResource", {
                    rowData: this.data.rowData,
                    listData: this.listData
                })
                .then(() => {
                    this.$message({
                        message: this.$t("zhiji.wiki.saveSuccess"),
                        type: "success"
                    });
                });
        }
    },
    mounted() {
        this.queryResourceList();
    }
};
</script>

<style lang="scss" scoped>
.height-base-title {
    position: relative;
    font-size: 16px;
    padding: 20px 16px;
    background: #fff;
    flex-grow: 0;
    &:after {
        display: inline-block;
        content: "";
        position: absolute;
        z-index: 99;
        bottom: 0;
        left: 0;
        height: 3px;
        width: 100%;
        box-shadow: 3px 3px 5px rgba(158, 159, 160, 0.15);
    }
}
.more-block-modal {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background-color: #fff;
    width: 100%;
    height: 100%;
    .list {
        display: flex;
        flex: 1;
        flex-direction: column;
        .more-block-list {
            flex: 1;
            overflow: auto;
        }
    }
    .list-bottom {
        padding: 16px 24px 16px 24px;
        border-top: 1px solid #d9e4ef;
        background: #fafbfd;
    }
    .return {
        display: inline-block;
        width: 20px;
        height: 20px;
        margin-right: 8px;
        vertical-align: text-bottom;
        cursor: pointer;
        background: url(/zhiji/images/ico-back.png);
        background-size: cover;
    }
}
</style>
